module.exports = __webpack_public_path__ + "img/2.72aabc56.png";